import React, { useEffect, useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { deleteSchedule } from "../../api/schedulesApi";
import { ensureCsrfToken, scheduleIdText } from "../../utils/scheduleHelpers";

function scheduleDeleteLabel(schedule) {
  const code = scheduleIdText(schedule);
  const title = String(schedule?.schedule_title ?? "").trim();
  if (code && title && code !== title) return `${code} (${title})`;
  return title || code || "this schedule";
}

export default function DeleteScheduleModal({ schedule, onClose, onSuccess, onError }) {
  const open = Boolean(schedule?.id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) setLoading(false);
  }, [open, schedule?.id]);

  const handleConfirm = async () => {
    const id = Number(schedule?.id);
    if (!Number.isFinite(id) || id <= 0) return;

    setLoading(true);
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      await deleteSchedule(id, csrfToken);
      onClose?.();
      onSuccess?.("Schedule deleted successfully");
    } catch (err) {
      onClose?.();
      onError?.(err?.message || "Failed to delete schedule");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Delete schedule"
      description="This soft-deletes the schedule record."
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? "Deleting…" : "Delete"}
          </GlobalButton>
        </div>
      }
    >
      <p style={{ fontSize: "0.9375rem", color: "#475569", lineHeight: 1.6 }}>
        Delete schedule <strong>{scheduleDeleteLabel(schedule)}</strong>? This cannot be
        undone from the admin panel.
      </p>
    </GlobalModal>
  );
}
